import { getEnvironmentLabel, isLocalhost } from "@maersk-global/shared-js";
import { AUTHORITY_URL } from "@/utils/application";
import { localStorage } from "reactive-localstorage";
import { environmentData } from "@/helper/environment";

export const getAuthorityUrl = (): string => {
  const environmentLabel: string = getEnvironmentLabel();

  return AUTHORITY_URL[environmentLabel] || "";
};
export const getJwtToken = () => {
  let id_token: any;
  for (const [key, value] of Object.entries(localStorage)) {
    if (key.includes(".access_token")) {
      id_token = value;
    }
  }
  return id_token;
};

const getRedirectUriWithCurrentParams = (): string => {
  const baseRedirectUri = environmentData.redirectUrl || window.location.origin + "/track-and-trace";
  const currentQuery = window.location.search;

  if (!currentQuery) {
    return baseRedirectUri;
  }

  try {
    const redirectUrl = new URL(baseRedirectUri, window.location.origin);
    const incomingParams = new URLSearchParams(currentQuery);

    for (const [key, value] of incomingParams.entries()) {
      redirectUrl.searchParams.set(key, value);
    }

    return redirectUrl.toString();
  } catch {
    return `${baseRedirectUri}${baseRedirectUri.includes("?") ? "&" : "?"}${currentQuery.slice(1)}`;
  }
};

export const initializeIamViaIgn = () => {
  if ("IGN_IAM_Initialiser" in window) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.IGN_IAM_Initialiser({
      appURL:
        isLocalhost(window.location.hostname) || window.location.origin.includes(".track-and-trace")
          ? window.location.origin
          : window.location.origin + "/track-and-trace",
      clientId: "apmt001",
      authority: getAuthorityUrl(),
      redirectUri: getRedirectUriWithCurrentParams()
    });
  }
};

export const ignLoginRedirect = () => {
  if ("IGN_IAM_Service_Provider" in window) {
    const interval = setInterval(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.IGN_IAM_Service_Provider.loginRedirect({
        response_type: "code",
        scopes: ["openid", "profile", "email"],
        redirectUri: getRedirectUriWithCurrentParams()
      });
      clearInterval(interval);
    }, 100);
  }
};

export const ignLogoutRedirect = () => {
  let attempts = 0;
  const maxAttempts = 50; // wait up to 5 seconds for IGN to be ready
  const tryLogout = setInterval(() => {
    attempts++;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window.IGN_IAM_Service_Provider?.logoutRedirect === "function") {
      clearInterval(tryLogout);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.IGN_IAM_Service_Provider.logoutRedirect({
        response_type: "code",
        scopes: ["openid", "profile", "email"],
        redirectUri: getRedirectUriWithCurrentParams()
      });
    } else if (attempts >= maxAttempts) {
      clearInterval(tryLogout);
      window.localStorage.clear();
      window.location.reload();
    }
  }, 100);
};
